import Ellipse from "../../shapes/shapes/Ellipse";
import Rectangle from "../../shapes/shapes/Rectangle";
import AbstractProvidedClass from "../../shared/AbstractProvidedClass";

export default class MoveAction extends AbstractProvidedClass {
    anchor;
    movedX = 0;
    movedY = 0;
    initialX;
    initialY;
    initialMouseX;
    initialMouseY;

    constructor(provider, mainElement, elements) {
        super(provider);

        this.mainElement = mainElement;
        this.selectedElements = elements;

        if (this.settings.snapToGrid) {
            this.setAnchor();
            this.initialMouseX = this.view.currentX;
            this.initialMouseY = this.view.currentY;
            if (this.mainElement instanceof Rectangle) {
                this.initialX = this.anchor.currentX + this.mainElement.currentX;
                this.initialY = this.anchor.currentY + this.mainElement.currentY;
            } else {
                this.initialX = this.anchor.currentX;
                this.initialY = this.anchor.currentY;
            }
        }
    }

    update() {
        let moveX = this.p.movedX / this.view.scale;
        let moveY = this.p.movedY / this.view.scale;
        if (this.anchor) {
            let dX = this.view.currentX - this.initialMouseX;
            let dY = this.view.currentY - this.initialMouseY;
            let newX = this.initialX + dX;
            let newY = this.initialY + dY;
            let newSnappedX = Math.round(newX / this.grid.minorSize) * this.grid.minorSize;
            let newSnappedY = Math.round(newY / this.grid.minorSize) * this.grid.minorSize;
            if (this.mainElement instanceof Rectangle) {
                moveX = Math.round((newSnappedX - (this.anchor.currentX + this.mainElement.currentX)) / this.view.scale);
                moveY = Math.round((newSnappedY - (this.anchor.currentY + this.mainElement.currentY)) / this.view.scale);
            } else {
                moveX = Math.round((newSnappedX - this.anchor.currentX) / this.view.scale);
                moveY = Math.round((newSnappedY - this.anchor.currentY) / this.view.scale);
            }
        }

        if (moveX != 0 || moveY != 0) {
            this.movedX += moveX;
            this.movedY += moveY;
            this.selectedElements.map((e) => e.move(moveX, moveY));
        }
    }

    finish() {
        this.actions.finish();
        this.changesMade();
    }

    undo() {
        this.selectedElements.map((e) => e.move(-this.movedX, -this.movedY));
    }

    redo() {
        this.selectedElements.map((e) => e.move(this.movedX, this.movedY));
    }

    setAnchor() {
        if (this.mainElement instanceof Ellipse) {
            this.anchor = this.mainElement;
        } else {
            this.anchor = this.mainElement.getClosestCoordinate();
        }
    }
}
